// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Np17p{display:flex;flex-direction:column;gap:2px}.Jt4SS{display:inline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ownerCell": `Np17p`,
	"ownerMore": `Jt4SS`
};
export default ___CSS_LOADER_EXPORT___;
